<div
  class="login-container"
  [ngStyle]="{
    'background-image': publicPageSettings && publicPageSettings.backgroungImage ? 'url(' + publicPageSettings.backgroungImage + ')' : '',
  }"
  >
  <div class="modal-login mat-elevation-z24">
    @if (isAdminTentantCogs) {
      @if (!isAdminTenantAuth) {
        <button mat-icon-button class="tenant-admin-cogs" (click)="goTenantAdmin()">
          <mat-icon fontSet="fa" fontIcon="fa-cogs"></mat-icon>
        </button>
      }
      @if (isAdminTenantAuth && !isMultiTenant) {
        <button mat-icon-button class="tenant-admin-close-cogs" (click)="closeTenantAdmin()">
          <mat-icon>close</mat-icon>
        </button>
      }
    }
    <div class="modal-login-form">
      @if (headerImage) {
        <img class="brand-logo" [src]="transform(headerImage)" [alt]="'accessibility_alt_brand_logo_img' | translate" />
      }
      @if (!isForgotForm) {
        <div class="login-form-container">
          @if (!isMultiTenant) {
            <div class="login-form-container">
              @if (!isTwoFactorMethod) {
                <div class="login-form-container">
                  @if (!isAuthenticated) {
                    <div class="login-form-container">
                      <span class="modal-title">{{ (this.isAdminTenantAuth ? 'login_tenantadmin_title' : 'login_title') | translate }}</span>
                      <form [formGroup]="loginForm" (ngSubmit)="login()" class="login-form">
                        <mat-form-field>
                          <mat-label>{{ 'login_placeholder_email' | translate }}</mat-label>
                          <input matInput formControlName="email" autocomplete="username" autofocus />
                          @if (isSubmitted && formControls.email.errors) {
                            <mat-error>
                              {{ 'login_error_required_email' | translate }}
                            </mat-error>
                          }
                        </mat-form-field>
                        <mat-form-field>
                          <mat-label>{{ 'login_placeholder_password' | translate }}</mat-label>
                          <input matInput type="password" formControlName="password" autocomplete="current-password" autofocus />
                          @if (isSubmitted && formControls.password.errors) {
                            <mat-error>
                              {{ 'login_error_required_password' | translate }}
                            </mat-error>
                          }
                        </mat-form-field>
                        @if (!isLoading) {
                          <div class="login-btn">
                            <button mat-flat-button color="primary" [disabled]="isSubmitted && isAuthenticated">
                              {{ 'login_button' | translate }}
                            </button>
                          </div>
                        }
                        @if (isLoading) {
                          <div class="login-spinner-container">
                            <mat-spinner diameter="50"></mat-spinner>
                          </div>
                        }
                        @if (isSubmitted && authError) {
                          <div>
                            <app-alert
                              status="error"
                              [message]="authError.errorKey | translate"
                              [tooltip]="authError.errorMessage !== authError.errorKey ? authError.errorMessage : null"
                            ></app-alert>
                          </div>
                        }
                        <a [routerLink]="[]" (click)="isForgotForm = true" class="text-button">
                          {{ 'login_forgot_password' | translate }}
                        </a>
                      </form>
                      @if (!isAdminTenantAuth && getOpenAuth() && getOpenAuth().length > 0) {
                        <mat-divider style="width: 100%"></mat-divider>
                        <div class="oauth-login">
                          @for (auth of getOpenAuth(); track auth) {
                            @if (auth.show) {
                              <div class="oauth-logo" (click)="oauthLogin(auth.link)">
                                <img [src]="transform(auth.image)" [alt]="'accessibility_alt_login_oauth_logo' | translate" />
                                <span>{{ auth.name }}</span>
                              </div>
                            }
                          }
                        </div>
                      }
                      @if (isAdminTenantAuth && getAdminOpenAuth() && getAdminOpenAuth().length > 0) {
                        <mat-divider style="width: 100%"></mat-divider>
                        <div class="oauth-login">
                          @for (auth of getAdminOpenAuth(); track auth) {
                            @if (auth.show) {
                              <div class="oauth-logo" (click)="oauthLogin(auth.link)">
                                <img [src]="transform(auth.image)" [alt]="'accessibility_alt_login_tenantadmin_oauth_logo' | translate" />
                                <span>{{ auth.name }}</span>
                              </div>
                            }
                          }
                        </div>
                      }
                    </div>
                  } @else {
                    <app-alert status="success" [message]="'login_message_success' | translate"></app-alert>
                  }
                </div>
              } @else {
                <!-- ONE TIME PIN TWO FACTOR METHOD -->
                @if (isOneTimePinTwoFactorMethod) {
                  <span class="modal-title">{{ 'login_onetimepasscode_title' | translate }}</span>
                  <form [formGroup]="loginOneTimePinForm" (ngSubmit)="sendOTP()" class="login-form">
                    <mat-form-field>
                      <mat-label>{{ 'login_placeholder_otp' | translate }}</mat-label>
                      <input matInput type="text" formControlName="otp" autocomplete="one-time-code" autofocus />
                      @if (isSubmitted && otpFormControls.otp.errors) {
                        <mat-error>
                          {{ 'login_error_required_otp' | translate }}
                        </mat-error>
                      }
                    </mat-form-field>
                    @if (!isLoading) {
                      <div class="login-btn">
                        <button mat-flat-button color="primary" [disabled]="isSubmitted && isAuthenticated">
                          {{ 'login_otp_button' | translate }}
                        </button>
                      </div>
                    }
                    @if (isLoading) {
                      <div class="login-spinner-container">
                        <mat-spinner diameter="50"></mat-spinner>
                      </div>
                    }
                    @if (isSubmitted && authError) {
                      <div>
                        <app-alert status="error" [message]="authError.errorKey | translate" [tooltip]="authError.errorMessage"></app-alert>
                      </div>
                    }
                    @if (showResendOtpSentAlert) {
                      <app-alert status="success" [message]="'login_resend_otp_sent' | translate"></app-alert>
                    }
                    @if (showResendOtpCooldownAlert) {
                      <app-alert
                        status="warning"
                        [message]="'login_resend_otp_cooldown_message' | translate: { seconds: resendCooldownRemaining }"
                      ></app-alert>
                    }
                    <a [routerLink]="[]" (click)="resendOTP()" class="text-button">
                      {{ 'login_resend_otp_button' | translate }}
                    </a>
                    <a [routerLink]="[]" (click)="resetLoginFormsStatus()" class="text-button">
                      {{ 'login_back_to_login_form' | translate }}
                    </a>
                  </form>
                }
              }
            </div>
          } @else {
            <span class="modal-title">{{ 'login_tenant_title' | translate }}</span>
            <form [formGroup]="loginMultitenantForm" (ngSubmit)="selectTenant()" class="login-form">
              <mat-form-field>
                <mat-select
                  disableOptionCentering
                  panelClass="finoffice-matselect-panel"
                  panelClass="finoffice-matselect-panel"
                  formControlName="tenant"
                  required
                  >
                  @for (tenant of tenants; track tenant) {
                    <mat-option class="form-field-option" [value]="tenant.key">
                      {{ tenant.value }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              @if (!isLoading) {
                <div class="login-btn">
                  <button mat-flat-button color="primary" [disabled]="isSubmitted && isAuthenticated">
                    {{ 'login_tenant_button' | translate }}
                  </button>
                </div>
              }
              @if (isLoading) {
                <div class="login-spinner-container">
                  <mat-spinner diameter="50"></mat-spinner>
                </div>
              }
              @if (isSubmitted && authError) {
                <div>
                  <app-alert status="error" [message]="authError.errorKey | translate" [tooltip]="authError.errorMessage"></app-alert>
                </div>
              }
              <a [routerLink]="[]" (click)="resetLoginFormsStatus()" class="text-button">
                {{ 'login_back_to_login_form' | translate }}
              </a>
            </form>
          }
        </div>
      } @else {
        @if (!isForgotMailSent) {
          <div>
            <span class="modal-title">{{ 'login_forgot_password_title' | translate }}</span>
            <form [formGroup]="forgotPasswordForm" (ngSubmit)="forgotPassword()" class="login-form">
              <mat-form-field>
                <mat-label>{{ 'login_placeholder_email' | translate }}</mat-label>
                <input matInput formControlName="email" autocomplete="username" autofocus />
                @if (isForgotSubmitted && forgotFormControls.email.errors) {
                  <mat-error>
                    {{ 'login_error_required_email' | translate }}
                  </mat-error>
                }
              </mat-form-field>
              <div class="login-btn">
                <button mat-flat-button color="primary" [disabled]="isForgotLoading()">
                  {{ 'login_forgot_password_button' | translate }}
                </button>
              </div>
              <div class="spinner-container">
                @if (isForgotLoading()) {
                  <div>
                    <mat-spinner diameter="50"></mat-spinner>
                  </div>
                }
              </div>
              @if (isForgotSubmitted && forgotError) {
                <div>
                  <app-alert status="error" [message]="forgotError.errorKey | translate" [tooltip]="forgotError.errorMessage"></app-alert>
                </div>
              }
              <a [routerLink]="[]" (click)="resetLoginFormsStatus()" class="text-button">
                {{ 'login_back_to_login_form' | translate }}
              </a>
            </form>
          </div>
        } @else {
          <app-alert
            status="success"
            [message]="'forgot_mail_sent_message_success' | translate"
            [tooltip]="forgotPasswordForm.get('email').value"
          ></app-alert>
        }
      }
    </div>
  </div>

  <div
    class="footer"
    [ngStyle]="{
      'background-color': publicPageSettings && publicPageSettings.footerBackgroundColor ? publicPageSettings.footerBackgroundColor : '',
    }"
    >
    @if (publicPageSettings) {
      <span
      [ngStyle]="{
        color: publicPageSettings && publicPageSettings.footerFontColor ? publicPageSettings.footerFontColor : '',
      }"
        >{{ publicPageSettings?.footerText }}
        <a
          [href]="publicPageSettings.footerLink"
        [ngStyle]="{
          color: publicPageSettings && publicPageSettings.footerLinkColor ? publicPageSettings.footerLinkColor : '',
        }"
          >{{ publicPageSettings?.footerLinkText }}</a
          >
          {{ publicPageSettings?.footerCopyright }}
        </span>
      }
    </div>
  </div>

